import Decimal from 'decimal.js';
import { utils } from "../utils";
import { fromDatestampArray, toDatestampArray } from "./time";
import { getLastXMonths } from "../utils/date.utils";
import { isSameMonth } from 'date-fns';
export class HistoricRevenueModel {
  static makeEmptyMonth() {
    let {
      date
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      date: toDatestampArray(date || new Date()),
      totalAmount: new Decimal(0)
    };
  }
  static fromDTO(historicPaidInvoices, historicPaidExternallyInvoices) {
    const formattedHistoricPaidInvoices = historicPaidInvoices.map(_ref => {
      let {
        rawRevenue,
        formattedDay
      } = _ref;
      return {
        date: toDatestampArray(new Date(formattedDay)),
        totalAmount: new Decimal(rawRevenue)
      };
    });
    return new HistoricRevenueModel(formattedHistoricPaidInvoices, historicPaidExternallyInvoices);
  }
  static fromHistoricInvoiceDTO(_ref2) {
    let {
      date,
      totalAmount
    } = _ref2;
    return {
      date,
      totalAmount: new Decimal(totalAmount)
    };
  }
  constructor(historicPaidInvoices, historicPaidExternallyInvoices) {
    this.historicPaidInvoices = historicPaidInvoices;
    this.historicPaidExternallyInvoices = historicPaidExternallyInvoices;
    this.historicPaidInvoices = historicPaidInvoices;
    this.historicPaidExternallyInvoices = historicPaidExternallyInvoices;
  }
  totalThisYear() {
    return utils.formatDollarAmount([...this.historicPaidExternallyInvoices, ...this.historicPaidInvoices].filter(_ref3 => {
      let {
        date
      } = _ref3;
      return date[0] === new Date().getFullYear();
    }).reduce((acc, invoice) => acc.plus(invoice.totalAmount), new Decimal(0)));
  }
  totalPaidExternally() {
    return utils.formatDollarAmount(this.historicPaidExternallyInvoices.reduce((acc, _ref4) => {
      let {
        totalAmount
      } = _ref4;
      return acc.plus(totalAmount);
    }, new Decimal(0)));
  }
  totalPaidInternally() {
    return utils.formatDollarAmount(this.historicPaidInvoices.reduce((acc, _ref5) => {
      let {
        totalAmount
      } = _ref5;
      return acc.plus(totalAmount);
    }, new Decimal(0)));
  }
  chartData(now) {
    const getItem = (date, invoices) => invoices.find(item => isSameMonth(fromDatestampArray(item.date), date)) || HistoricRevenueModel.makeEmptyMonth({
      date
    });
    return getLastXMonths(now, 12).map(date => ({
      date,
      [RevenueStatus.Paid]: getItem(date, this.historicPaidInvoices),
      [RevenueStatus.PaidExternally]: getItem(date, this.historicPaidExternallyInvoices)
    }));
  }
  isEmpty() {
    return this.historicPaidExternallyInvoices.length === 0;
  }
}
export let RevenueStatus = /*#__PURE__*/function (RevenueStatus) {
  RevenueStatus["Paid"] = "paid";
  RevenueStatus["PaidExternally"] = "paidExternally";
  return RevenueStatus;
}({});